import * as React from "react";
const CreateWarrantyClaimView = React.lazy(() => import("./CreateWarrantyClaimViewContainer"));

export { CreateWarrantyClaimView };
